'use client'

import { sendAnalyticsEvent } from '../../../../MyStichtingOpenHelpers/src/static'
import { useEffect } from 'react'
import { mapToSearchAnalyticsEvent } from './helpers/mappers'
import { SEARCH_INVOKED_EVENT } from './searchInvokedAnalytics'

/**
 * Listens for `SEARCH_INVOKED_EVENT` and pushes the mapped `search` payload to the data layer.
 *
 * Call sites (e.g. `Search`) use `dispatchSearchInvoked` (see `searchInvokedAnalytics.ts`) with only a
 * string instead of importing `sendAnalyticsEvent`, GA event shapes, or mappers. That keeps UI thin,
 * centralizes mapping here, and allows other features to reuse the same analytics path without coupling
 * directly to the data layer.
 */
export const useSearchAnalytics = () => {
    useEffect(() => {
        const abortController = new AbortController()
        const { signal } = abortController

        const onSearchInvoked = (e: Event) => {
            const custom = e as CustomEvent<{ searchTerm: string }>
            const raw = custom.detail?.searchTerm
            const searchTerm = typeof raw === 'string' ? raw.trim() : ''
            sendAnalyticsEvent(mapToSearchAnalyticsEvent(searchTerm))
        }

        document.addEventListener(SEARCH_INVOKED_EVENT, onSearchInvoked, { signal })

        return () => {
            abortController.abort()
        }
    }, [])
}
